<template>
  <form-layout
    class="scope-item-form"
    :loading="isLoading"
    @save="saveScopeItem"
  >
    <template #title>
      <h1 class="uppercase">{{ titleText }}</h1>
    </template>
    <template #body>
      <bdg-text-field
        ref="name"
        name="Scope item name"
        v-model="formData.name"
        required
      />

      <bdg-dropdown
        ref="type"
        name="Type"
        :options="types"
        v-model="formData.type"
        required
      />

      <bdg-multi-add
        name="Default task list"
        add-item-text="Add task"
        empty-state-message="No tasks added"
        @removed="removeTask"
        v-model="tasksStrings"
        required
      />
    </template>
  </form-layout>
</template>

<script>
import FormLayout from "../views/layouts/FormLayout";
import BdgTextField from "./fields/BdgTextField";
import BdgDropdown from "./fields/BdgDropdown";
import {
  ScopeDocumentTypeLabels,
  ScopeDocumentTypes
} from "../constants/contract-enums";
import BdgMultiAdd from "./fields/BdgMultiAdd";
import { validateRequiredRefs } from "../helpers";

export default {
  name: "ScopeItemForm",
  components: { BdgMultiAdd, BdgDropdown, BdgTextField, FormLayout },
  props: {
    id: Number,
    name: String,
    type: String,
    default_tasks: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formData: {
        id: this.id,
        name: this.name,
        type: this.type,
        default_tasks: this.default_tasks.slice(),
        deleted_tasks: []
      },
      types: Object.values(ScopeDocumentTypes).map(slug => {
        return {
          label: ScopeDocumentTypeLabels[slug],
          value: slug
        };
      }),
      requiredRefs: ["name", "type"]
    };
  },
  computed: {
    titleText() {
      return this.id ? "Edit Scope Item" : "Add Scope Item";
    },
    tasksStrings: {
      get() {
        return this.formData.default_tasks.map(task => task.name);
      },
      set(val) {
        this.formData.default_tasks = val.map(taskString => {
          const index = this.formData.default_tasks.findIndex(
            task => task.name === taskString
          );

          if (index > -1) {
            return this.formData.default_tasks[index];
          }

          return {
            name: taskString
          };
        });
      }
    },
    isStoringScopeItem() {
      return this.$store.state.Settings.isStoringScopeItem;
    },
    isUpdatingScopeItem() {
      return this.$store.state.Settings.isUpdatingScopeItem;
    },
    isLoading() {
      return this.id ? this.isUpdatingScopeItem : this.isStoringScopeItem;
    }
  },
  methods: {
    removeTask(taskString) {
      const index = this.default_tasks.findIndex(
        task => task.name === taskString
      );
      if (index > -1 && this.default_tasks[index].id) {
        this.formData.deleted_tasks.push(this.default_tasks[index].id);
      }
    },
    validate() {
      return validateRequiredRefs(this, true);
    },
    saveScopeItem() {
      if (!this.validate()) {
        return;
      }

      if (this.id) {
        this.$store.dispatch("updateScopeItem", this.formData);
      } else {
        this.$store.dispatch("storeScopeItem", this.formData);
      }
    }
  }
};
</script>

<style scoped></style>
